/** The behaviors module's reads and writes of the API: TanStack Query hooks, and a few plain calls for a form to make as it is filled in. */
import { useQuery } from '@tanstack/react-query'
import { apiGet } from '../core/index.js'
import type { BehaviorEvent } from './types.js'

/** A worker's reported custom-behavior events, most recent first. */
export function useWorkerBehaviorEvents(workerId: string | null) {
  return useQuery({
    queryKey: ['worker-behavior-events', workerId],
    queryFn: () => apiGet<BehaviorEvent[]>(`/workers/${workerId as string}/behavior-events`),
    enabled: workerId !== null,
  })
}
